export default "__VITE_ASSET__UFl0wuzj__"